module.exports = __webpack_public_path__ + "static/Cape Privacy-e7a54011edb1b1dbc616f0abc9846dd7.jpg";